export function parseRuntimeJackpot (value) {
  if (value === null || value === undefined || value === '') return null
  const num = Number(value)
  if (!Number.isFinite(num) || num < 0) return null
  return num
}

export function isDollarJackpotCurrency (currency) {
  return String(currency || '').trim() === '$'
}

export function normalizeJackpotValue (value, currency) {
  const num = parseRuntimeJackpot(value)
  if (num == null) return null
  if (isDollarJackpotCurrency(currency)) {
    return Math.round(num * 100) / 100
  }
  return Math.floor(num)
}

export function formatJackpotDisplayValue (value, currency) {
  const num = Number(value)
  if (!Number.isFinite(num)) {
    return isDollarJackpotCurrency(currency) ? '0.00' : '0'
  }
  if (isDollarJackpotCurrency(currency)) {
    return num.toLocaleString('ko-KR', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    })
  }
  return Math.floor(num).toLocaleString('ko-KR')
}
